import { useState } from 'react';
import type { TaskNote } from '../types';

interface Props {
  notes: TaskNote[];
  onAdd: (body: string) => Promise<void>;
}

export function NotesTimeline({ notes, onAdd }: Props) {
  const [draft, setDraft] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit() {
    const body = draft.trim();
    if (!body || busy) return;
    setBusy(true);
    try {
      await onAdd(body);
      setDraft('');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="notes-timeline">
      <h3>Notes</h3>
      {notes.length === 0 ? (
        <p className="muted">No notes yet.</p>
      ) : (
        <ul className="notes-list">
          {notes.map((note) => (
            <li key={note.noteId}>
              <div className="note-meta">
                {new Date(note.createdAt).toLocaleString()}
              </div>
              <div className="note-body">{note.body}</div>
            </li>
          ))}
        </ul>
      )}
      <div className="note-composer">
        <textarea
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          placeholder="Add a note — task will move to Pending"
          rows={3}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
              e.preventDefault();
              void submit();
            }
          }}
        />
        <button onClick={() => void submit()} disabled={busy || !draft.trim()}>
          Add note
        </button>
      </div>
    </div>
  );
}
